module.exports = __webpack_public_path__ + "img/feature-01.985f2acf.png";